import { Component } from 'react'

import classNames from 'classnames'
import PropTypes from 'prop-types'
import Truncate from 'react-truncate'

import { numberWithCommas } from 'utils/formatters'

import Checkbox from 'components/Core/Checkbox/Checkbox'
import Tooltip from 'components/Core/Tooltip/Tooltip'

import styles from './StaticCountItem.module.css'

class StaticCountItem extends Component {
  state = {
    isTruncated: false,
  }

  handleTruncate = (isTruncated) => {
    if (!this.state.isTruncated && isTruncated) {
      this.setState({ isTruncated })
    }
  }

  render() {
    const { title, count, multiple, selectable, onSelect, checked } = this.props

    const text = (
      <Truncate
        className={classNames(styles.titleText, {
          [styles.multiple]: multiple,
        })}
        onTruncate={this.handleTruncate}
      >
        {title}
      </Truncate>
    )

    const textWithTooltip = (
      <Tooltip content={title} position="bottom left" trigger={text} />
    )

    return (
      <div key={title} className={classNames({ [styles.singleRow]: multiple })}>
        <div
          className={classNames(styles.title, { [styles.multiple]: multiple })}
        >
          {selectable && (
            <Checkbox small onClick={onSelect} checked={checked} />
          )}
          {this.state.isTruncated ? textWithTooltip : text}
          {multiple && (
            <div className={styles.multipleCount}>
              {count === null ? '' : numberWithCommas(count) || 0}
            </div>
          )}
        </div>
        {!multiple && (
          <div className={classNames(styles.count)}>
            {count === null ? '' : numberWithCommas(count) || 0}
          </div>
        )}
      </div>
    )
  }
}

StaticCountItem.propTypes = {
  title: PropTypes.string,
  count: PropTypes.number,
  multiple: PropTypes.bool,
  selectable: PropTypes.bool,
  onSelect: PropTypes.func,
  checked: PropTypes.bool,
}

StaticCountItem.defaultProps = {
  title: '',
  count: 0,
  multiple: false,
  selectable: false,
  onSelect: () => {},
  checked: false,
}

export default StaticCountItem
